import { ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

import {
    addExpediteShippingOrder,
    ExpediteShippingOrderParameter,
    ExpediteShippingParameter,
} from "@TKCCP/Services/tkccpExpediteShippingService";
import { ExpediteShippingOrderHistoryModel } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string>,
    ExpediteShippingParameter,
    ExpediteShippingOrderHistoryModel,
    { expediteShippingOrderModel: ExpediteShippingOrderHistoryModel }
>;

export const AddExpediteShippingOrder = (model: ExpediteShippingOrderParameter) => {
    try {
        const result = addExpediteShippingOrder(model);

        // eslint-disable-next-line no-empty
    } catch (error) {}
};
